module.exports = __webpack_public_path__ + "img/banner3_5_zh.be61f575.png";